import { render, staticRenderFns } from "./GaClient.vue?vue&type=template&id=f9dc0366&scoped=true"
import script from "./GaClient.vue?vue&type=script&lang=js"
export * from "./GaClient.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9dc0366",
  null
  
)

export default component.exports